import { render, staticRenderFns } from "./deleteDataPrivilegeUnit.vue?vue&type=template&id=1003d5ea&scoped=true"
import script from "./deleteDataPrivilegeUnit.vue?vue&type=script&lang=js"
export * from "./deleteDataPrivilegeUnit.vue?vue&type=script&lang=js"
import style0 from "./deleteDataPrivilegeUnit.vue?vue&type=style&index=0&id=1003d5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1003d5ea",
  null
  
)

export default component.exports